import React, { PureComponent } from 'react';

class LoadingRoute extends PureComponent {
  /*componentWillReceiveProps(nextProps) {
    const { end } = this.props;
    const { isLoading } = nextProps;
    if (!isLoading)
      end();
  }
  componentDidMount() {
    const { isLoading, start } = this.props;
    if (isLoading)
      start();
  }
  componentWillUnmount() {
    const { end } = this.props;
    end();
  }*/
  render() {
    const { error, timedOut, pastDelay, retry } = this.props;
    if (error || timedOut)
      return (
        <div role="alert" style={{ padding: '24px' }}>
          <h2>This page could not be opened.</h2>
          <p>Please try again or reload the page.</p>
          {retry && <button type="button" onClick={retry}>Try again</button>}
          <button type="button" onClick={() => window.location.reload()}>Reload page</button>
          <p><a href="/export">Back to exports</a></p>
        </div>
      );
    if (pastDelay)
      return <p role="status" style={{ padding: '24px' }}>Loading page…</p>;
    return null;
  }
}

export default LoadingRoute;
